<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Enter a title and a description for the image') }}</h4>
    </div>
    <div class="modal-body">
      <editor-tabs id="tabNavi" :tabs="[{ id: 'general', label: _('General') }, { id: 'settings', label: _('Settings') }]" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <div v-bind="tabPanel('general')" class="tab-pane active" id="general" v-if="isTabActive('general')" key="general" ref="generalTab">
          <div class="row">   
            <div class="col-md-12">
              <div class="form-group languageversioned">
                <label for="title">{{ _('Title') }}</label>
                <input class="form-control" type="text" name="title" :placeholder="_('Enter a caption for the image')" id="captionTitle" v-model="title" />
              </div>
            </div>
          </div>
          <div class="row">   
            <div class="col-xs-12">
              <div class="form-group languageversioned"> 
                <label class="message" for="captionDescription">{{ _('Description') }}</label>
                <textarea class="form-control" id="captionDescription" name="description" rows="8" wrap="virtual" v-model="description"></textarea>
              </div>
            </div>
          </div>
          <div class="row">   
            <div class="col-xs-12">
              <div class="form-group">  
                <label for="title">{{ _('Video') }}</label> 
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-fw fa-youtube"></i> Youtube</span>
                  <input class="form-control" type="text" name="video" :placeholder="_('Enter the URL of a video to show instead of the image')" id="captionVideo" v-model="video" :disabled="isCookieManagerEnabled ? undefined : true" /> 
                </div>
              </div>
              <p class="text-info" v-if="!isCookieManagerEnabled"><i class="fa fa-fw fa-info"></i> {{ _('Cookie management is required to use this functionality.') }}</p>
            </div>
          </div>
        </div>
        <div v-bind="tabPanel('settings')" class="tab-pane active" id="settings" v-if="isTabActive('settings')" key="settings" ref="settingsTab">
          <div class="row">   
            <div class="col-md-12">
              <div class="form-group">
                <label for="smartcrop">{{ _('Smart Crop') }}</label><br />
                <select class="form-control" id="smartCrop" v-model="smartcrop">
                  <option value="default">{{ _('System default') }}</option>
                  <option value="full">{{ _('Fully enabled with face detection') }}</option>
                  <option value="nofaces">{{ _('Enabled without face detection') }}</option>
                  <option value="disable">{{ _('Disabled') }}</option>
                </select>
                <i>{{ _('You can override the Smart Crop setting on a picture-by-picture basis.') }}</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="save"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>
import settingshelpers from '~/lib/settingshelpers'
import tabs from '~/lib/tabs'

export default {
  props: ['defaultTitle', 'defaultDescription', 'defaultVideo', 'defaultSmartCrop', 'source', 'settings'],
  data () {
    return {
      title: this.defaultTitle,
      description: this.defaultDescription,
      video: this.defaultVideo,
      smartcrop: this.defaultSmartCrop,
      maxHeight: 0
    }
  },
  mixins: [settingshelpers, tabs],
  computed: {
    isCookieManagerEnabled () {
      return this.isFeatureEnabled('cookiebot') && (this.settings.cookiebotid || parseInt(this.settings.customcookiemanager) || this.settings.cookiemanager)
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', {
        title: this.title, 
        description: this.description, 
        video: this.video, 
        smartcrop: this.smartcrop,
        source: this.source
      })
    },
  },
  watch: { // This could be made more generic
    activeTab (newValue) {
      this.$nextTick(() => {
        if (newValue === 'settings') {
          this.$refs.settingsTab.style.height = `${this.maxHeight}px`
        }
      })
    }
  },
  mounted () {
    this.maxHeight = this.$refs.generalTab?.offsetHeight
  }
}
</script>

